import {FC} from 'react';
import {styled} from 'styled-components';

import {LoadingIndicator} from '@shared-web/components/core/loading_indicator';
import {useTheme} from '@shared-web/theme/theme_context';

interface LoadingScreenProps {}

export const LoadingScreen: FC<LoadingScreenProps> = () => {
  const {
    main: {accentColor},
  } = useTheme();
  return (
    <Wrapper>
      <Message $color={accentColor}>LOADING</Message>
      <LoadingIndicator size={64} />
    </Wrapper>
  );
};

LoadingScreen.displayName = 'LoadingScreen';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 32px;
  width: 100%;
  height: 100%;
`;

const Message = styled.div<{$color: string}>`
  font-size: 4vw;
  color: ${p => p.$color};
`;
